export function getColumns() {
    return [
        {
            field: "id",
            headerName: "ID",
            flex: 1,
            editable: false,
        },
        {
            field: "level",
            headerName: "Level",
            flex: 1,
            editable: false,
            alignItems: "center",
        },
    ];
}
